import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getCategoryByRestaurant} from 'api/requests';
import {ICategoryByProviderResponse, ICategoryResponse} from 'types';

export const useCategoryByRestaurant = (
  queryKey: QueryKey,
  options: UseQueryOptions<ICategoryByProviderResponse[]>,
) => {
  return useQuery<ICategoryResponse[]>({
    queryKey,
    queryFn: () => getCategoryByRestaurant(),
    ...options,
  });
};
